/**
 * @module @aab/utilities/languageObserver
 */
/**
 *
 * @param {function} callback - function to be executed when language is changed
 */
const onLanguageChange = (callback) => {
  if (callback instanceof Function) {
    const target = document.documentElement;
    // For more information, see https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver/MutationObserver
    const observer = new MutationObserver((mutations) => {
      mutations.forEach(() => {
        // Since we only want to observe the lang attribute we can pass it back to the callback in this way.
        // If we have more attributes or things to observe we need to modify this.
        callback(target.lang);
      });
    });

    const config = { attributes: true, attributeFilter: ['lang'] };
    observer.observe(target, config);
  } else {
    throw new Error('You should specify a function which is called when the language is changed');
  }
};

export default {
  onLanguageChange,
};
